import React from "react";
import {MenuItem, TextField, Typography} from "@mui/material";
import {forms, objects} from "@atttomyx/shared-utils";
import "./typeRoleForm.css";

const TypeRoleForm = (props) => {
    const { roles, data, onChange: onSync } = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);

        modified[field] = value;
        modified.valid = data.roles.length > 0;

        onSync(modified);
    };

    return <div className="type-role-form">
        <Typography variant="h5">
            Roles
        </Typography>
        <div className="field">
            <TextField
                label="Roles"
                required={true}
                select={true}
                value={forms.sanitizeMulti(data.roles)}
                onChange={(event) => onChange("roles", event.target.value)}
                SelectProps={{
                    multiple: true,
                    renderValue: () => data.roles.length,
                }}
            >
                {roles.map((role) =>
                    <MenuItem key={role} value={role}>
                        {role}
                    </MenuItem>)}
            </TextField>
        </div>
    </div>
};

export default TypeRoleForm;
